import { AccountVerifiedIcon } from "./AccountVerifiedIcon";
import { AddIcon } from "./AddIcon";
import { AddFillIcon } from "./AddFillIcon";
import { AfterpayHomeIcon } from "./AfterpayHomeIcon";
import { AfterpayMerchantsIcon } from "./AfterpayMerchantsIcon";
import { AlertIcon } from "./AlertIcon";
import { AlertFillIcon } from "./AlertFillIcon";
import { AlertOfflineIcon } from "./AlertOfflineIcon";
import { AlertOnlineIcon } from "./AlertOnlineIcon";
import { AlertOutlineIcon } from "./AlertOutlineIcon";
import { AlertReportedFillIcon } from "./AlertReportedFillIcon";
import { AnniversaryIcon } from "./AnniversaryIcon";
import { AnniversaryFillIcon } from "./AnniversaryFillIcon";
import { AtmIcon } from "./AtmIcon";
import { AtmFillIcon } from "./AtmFillIcon";
import { AttachIcon } from "./AttachIcon";
import { AvatarIcon } from "./AvatarIcon";
import { AvatarFillIcon } from "./AvatarFillIcon";
import { BackCenteredIcon } from "./BackCenteredIcon";
import { BalanceIcon } from "./BalanceIcon";
import { BankAccountIcon } from "./BankAccountIcon";
import { BankLinkedIcon } from "./BankLinkedIcon";
import { BillsIcon } from "./BillsIcon";
import { BiometricsFaceIcon } from "./BiometricsFaceIcon";
import { BiometricsFingerprintIcon } from "./BiometricsFingerprintIcon";
import { BitcoinLightningIcon } from "./BitcoinLightningIcon";
import { BlockIcon } from "./BlockIcon";
import { BorrowIcon } from "./BorrowIcon";
import { BotMicIcon } from "./BotMicIcon";
import { BPayIcon } from "./BPayIcon";
import { BulletGenericIcon } from "./BulletGenericIcon";
import { BundleSafeIcon } from "./BundleSafeIcon";
import { BundleSteadyIcon } from "./BundleSteadyIcon";
import { BundleWealthIcon } from "./BundleWealthIcon";
import { BusinessIcon } from "./BusinessIcon";
import { BusinessEarningsIcon } from "./BusinessEarningsIcon";
import { BusinessInformativeIcon } from "./BusinessInformativeIcon";
import { CameraFillIcon } from "./CameraFillIcon";
import { CardActiveIcon } from "./CardActiveIcon";
import { CardAddIcon } from "./CardAddIcon";
import { CardAfterpayIcon } from "./CardAfterpayIcon";
import { CardBasicIcon } from "./CardBasicIcon";
import { CardBasicFillIcon } from "./CardBasicFillIcon";
import { CardCreditIcon } from "./CardCreditIcon";
import { CardDesignIcon } from "./CardDesignIcon";
import { CardDesignFillIcon } from "./CardDesignFillIcon";
import { CardInactiveIcon } from "./CardInactiveIcon";
import { CardNewIcon } from "./CardNewIcon";
import { CardRefreshIcon } from "./CardRefreshIcon";
import { CardStripIcon } from "./CardStripIcon";
import { CardSupportIcon } from "./CardSupportIcon";
import { CaretDownIcon } from "./CaretDownIcon";
import { CaretUpIcon } from "./CaretUpIcon";
import { CashAppCustomerIcon } from "./CashAppCustomerIcon";
import { CashAppPayIcon } from "./CashAppPayIcon";
import { CategoryAccessoriesIcon } from "./CategoryAccessoriesIcon";
import { CategoryAccessoriesAltIcon } from "./CategoryAccessoriesAltIcon";
import { CategoryAccessoriesHatsIcon } from "./CategoryAccessoriesHatsIcon";
import { CategoryAdultIcon } from "./CategoryAdultIcon";
import { CategoryApparelIcon } from "./CategoryApparelIcon";
import { CategoryApparelAltIcon } from "./CategoryApparelAltIcon";
import { CategoryAutoIcon } from "./CategoryAutoIcon";
import { CategoryBarIcon } from "./CategoryBarIcon";
import { CategoryBusinessServicesIcon } from "./CategoryBusinessServicesIcon";
import { CategoryCafeIcon } from "./CategoryCafeIcon";
import { CategoryCoffeeIcon } from "./CategoryCoffeeIcon";
import { CategoryDepartmentStoreIcon } from "./CategoryDepartmentStoreIcon";
import { CategoryDesignerIcon } from "./CategoryDesignerIcon";
import { CategoryDiyIcon } from "./CategoryDiyIcon";
import { CategoryEnergyIcon } from "./CategoryEnergyIcon";
import { CategoryEntertainmentIcon } from "./CategoryEntertainmentIcon";
import { CategoryEtfIcon } from "./CategoryEtfIcon";
import { CategoryExperiencesIcon } from "./CategoryExperiencesIcon";
import { CategoryFashionIcon } from "./CategoryFashionIcon";
import { CategoryFastFoodIcon } from "./CategoryFastFoodIcon";
import { CategoryFinanceIcon } from "./CategoryFinanceIcon";
import { CategoryFitnessIcon } from "./CategoryFitnessIcon";
import { CategoryFoodDrinkIcon } from "./CategoryFoodDrinkIcon";
import { CategoryFoodDrinkAltIcon } from "./CategoryFoodDrinkAltIcon";
import { CategoryFragrancesIcon } from "./CategoryFragrancesIcon";
import { CategoryFurnitureIcon } from "./CategoryFurnitureIcon";
import { CategoryGardenIcon } from "./CategoryGardenIcon";
import { CategoryGasStationIcon } from "./CategoryGasStationIcon";
import { CategoryGroceryIcon } from "./CategoryGroceryIcon";
import { CategoryHandbagsIcon } from "./CategoryHandbagsIcon";
import { CategoryHardwareIcon } from "./CategoryHardwareIcon";
import { CategoryHealthBeautyIcon } from "./CategoryHealthBeautyIcon";
import { CategoryHealthMedicalIcon } from "./CategoryHealthMedicalIcon";
import { CategoryHomeIcon } from "./CategoryHomeIcon";
import { CategoryHomeAutoIcon } from "./CategoryHomeAutoIcon";
import { CategoryHotelIcon } from "./CategoryHotelIcon";
import { CategoryIpoIcon } from "./CategoryIpoIcon";
import { CategoryJewelryIcon } from "./CategoryJewelryIcon";
import { CategoryKidsIcon } from "./CategoryKidsIcon";
import { CategoryMediaIcon } from "./CategoryMediaIcon";
import { CategoryMovingIcon } from "./CategoryMovingIcon";
import { CategoryOnlineIcon } from "./CategoryOnlineIcon";
import { CategoryPetStoreIcon } from "./CategoryPetStoreIcon";
import { CategoryPharmacyIcon } from "./CategoryPharmacyIcon";
import { CategoryPopularIcon } from "./CategoryPopularIcon";
import { CategoryRentIcon } from "./CategoryRentIcon";
import { CategoryRestaurantIcon } from "./CategoryRestaurantIcon";
import { CategoryShoesIcon } from "./CategoryShoesIcon";
import { CategoryShoesAltIcon } from "./CategoryShoesAltIcon";
import { CategoryShoesHeelIcon } from "./CategoryShoesHeelIcon";
import { CategoryShoppingIcon } from "./CategoryShoppingIcon";
import { CategoryShoppingAltIcon } from "./CategoryShoppingAltIcon";
import { CategoryShoppingCenterIcon } from "./CategoryShoppingCenterIcon";
import { CategorySportsIcon } from "./CategorySportsIcon";
import { CategorySportsAltIcon } from "./CategorySportsAltIcon";
import { CategoryTechIcon } from "./CategoryTechIcon";
import { CategoryTechnologyIcon } from "./CategoryTechnologyIcon";
import { CategoryTourismIcon } from "./CategoryTourismIcon";
import { CategoryToysIcon } from "./CategoryToysIcon";
import { CategoryTransporationAltIcon } from "./CategoryTransporationAltIcon";
import { CategoryTransportationIcon } from "./CategoryTransportationIcon";
import { CategoryTravelIcon } from "./CategoryTravelIcon";
import { CategoryUtilitiesIcon } from "./CategoryUtilitiesIcon";
import { CharityIcon } from "./CharityIcon";
import { ChatActiveIcon } from "./ChatActiveIcon";
import { ChatSmartIcon } from "./ChatSmartIcon";
import { CheckIcon } from "./CheckIcon";
import { CheckFillIcon } from "./CheckFillIcon";
import { CheckOutlineIcon } from "./CheckOutlineIcon";
import { ClearIcon } from "./ClearIcon";
import { ClearFieldIcon } from "./ClearFieldIcon";
import { CoinsIcon } from "./CoinsIcon";
import { CollapseIcon } from "./CollapseIcon";
import { CollapseCenteredIcon } from "./CollapseCenteredIcon";
import { CommChatIcon } from "./CommChatIcon";
import { CommEmailIcon } from "./CommEmailIcon";
import { CommEmailFillIcon } from "./CommEmailFillIcon";
import { CommPhoneFillIcon } from "./CommPhoneFillIcon";
import { CommSmsIcon } from "./CommSmsIcon";
import { CommSmsFillIcon } from "./CommSmsFillIcon";
import { ContactAddIcon } from "./ContactAddIcon";
import { ContactFalseIcon } from "./ContactFalseIcon";
import { ContactTrueIcon } from "./ContactTrueIcon";
import { ControlIcon } from "./ControlIcon";
import { CopyIcon } from "./CopyIcon";
import { CurrencyBtcIcon } from "./CurrencyBtcIcon";
import { CurrencyEurIcon } from "./CurrencyEurIcon";
import { CurrencyGbpIcon } from "./CurrencyGbpIcon";
import { CurrencyUsdIcon } from "./CurrencyUsdIcon";
import { CustomizeBrushFillIcon } from "./CustomizeBrushFillIcon";
import { DataIcon } from "./DataIcon";
import { DateIcon } from "./DateIcon";
import { DateStartIcon } from "./DateStartIcon";
import { DateStopIcon } from "./DateStopIcon";
import { DeliveryIcon } from "./DeliveryIcon";
import { DepositIcon } from "./DepositIcon";
import { DepositBarcodeIcon } from "./DepositBarcodeIcon";
import { DepositCheckIcon } from "./DepositCheckIcon";
import { DepositPaperIcon } from "./DepositPaperIcon";
import { DeviceDesktopIcon } from "./DeviceDesktopIcon";
import { DeviceLaptopIcon } from "./DeviceLaptopIcon";
import { DeviceMobileIcon } from "./DeviceMobileIcon";
import { DeviceTapIcon } from "./DeviceTapIcon";
import { DineInIcon } from "./DineInIcon";
import { DiscountMaximumIcon } from "./DiscountMaximumIcon";
import { DiscountMinimumIcon } from "./DiscountMinimumIcon";
import { DiscountPercentageIcon } from "./DiscountPercentageIcon";
import { DiscountTagIcon } from "./DiscountTagIcon";
import { DiscountTagFillIcon } from "./DiscountTagFillIcon";
import { DocumentIcon } from "./DocumentIcon";
import { DocumentCertificateIcon } from "./DocumentCertificateIcon";
import { DocumentCourtOrderIcon } from "./DocumentCourtOrderIcon";
import { DocumentFillIcon } from "./DocumentFillIcon";
import { DocumentPaystubIcon } from "./DocumentPaystubIcon";
import { DocumentQuillIcon } from "./DocumentQuillIcon";
import { DocumentW2Icon } from "./DocumentW2Icon";
import { DownloadIcon } from "./DownloadIcon";
import { DowntrendIcon } from "./DowntrendIcon";
import { DrawIcon } from "./DrawIcon";
import { EditIcon } from "./EditIcon";
import { EmployerIcon } from "./EmployerIcon";
import { ExpandIcon } from "./ExpandIcon";
import { ExpandCenteredIcon } from "./ExpandCenteredIcon";
import { FailedIcon } from "./FailedIcon";
import { FailedFillIcon } from "./FailedFillIcon";
import { FailedOutlineIcon } from "./FailedOutlineIcon";
import { FamilyIcon } from "./FamilyIcon";
import { FamilyExpenseIcon } from "./FamilyExpenseIcon";
import { FastIcon } from "./FastIcon";
import { FavoriteIcon } from "./FavoriteIcon";
import { FavoriteFillIcon } from "./FavoriteFillIcon";
import { FdicIcon } from "./FdicIcon";
import { FlashlightFillIcon } from "./FlashlightFillIcon";
import { FlashlightOffFillIcon } from "./FlashlightOffFillIcon";
import { FlashOffIcon } from "./FlashOffIcon";
import { FlashOnIcon } from "./FlashOnIcon";
import { FlatFeeIcon } from "./FlatFeeIcon";
import { FpoBurstIcon } from "./FpoBurstIcon";
import { FpoShrimpIcon } from "./FpoShrimpIcon";
import { GiftIcon } from "./GiftIcon";
import { GiftcardIcon } from "./GiftcardIcon";
import { GooglePayIcon } from "./GooglePayIcon";
import { GovernmentFlagIcon } from "./GovernmentFlagIcon";
import { GridViewIcon } from "./GridViewIcon";
import { HandoutIcon } from "./HandoutIcon";
import { HashIcon } from "./HashIcon";
import { HeartbeatIcon } from "./HeartbeatIcon";
import { HelpIcon } from "./HelpIcon";
import { HelpFillIcon } from "./HelpFillIcon";
import { HelpOutlineIcon } from "./HelpOutlineIcon";
import { HelpSimpleIcon } from "./HelpSimpleIcon";
import { HsaCardIcon } from "./HsaCardIcon";
import { HyperlinkIcon } from "./HyperlinkIcon";
import { IdeaIcon } from "./IdeaIcon";
import { IdGovernmentIcon } from "./IdGovernmentIcon";
import { IdPassportIcon } from "./IdPassportIcon";
import { ImageIcon } from "./ImageIcon";
import { InformationIcon } from "./InformationIcon";
import { InformationFillIcon } from "./InformationFillIcon";
import { InformationOutlineIcon } from "./InformationOutlineIcon";
import { InsightsIcon } from "./InsightsIcon";
import { InstantIcon } from "./InstantIcon";
import { InstantFillIcon } from "./InstantFillIcon";
import { InternationalIcon } from "./InternationalIcon";
import { InvestingIcon } from "./InvestingIcon";
import { InvestingCustomBuyIcon } from "./InvestingCustomBuyIcon";
import { InvestingCustomSellIcon } from "./InvestingCustomSellIcon";
import { IrsPrepaidIcon } from "./IrsPrepaidIcon";
import { KeypadDeleteIcon } from "./KeypadDeleteIcon";
import { LikeIcon } from "./LikeIcon";
import { LimitsIcon } from "./LimitsIcon";
import { LimitsFillIcon } from "./LimitsFillIcon";
import { LinkOutIcon } from "./LinkOutIcon";
import { LocalIcon } from "./LocalIcon";
import { LocationIcon } from "./LocationIcon";
import { LocationDuoIcon } from "./LocationDuoIcon";
import { LocationFillIcon } from "./LocationFillIcon";
import { LockLockedIcon } from "./LockLockedIcon";
import { LockLockedFillIcon } from "./LockLockedFillIcon";
import { LockUnlockedIcon } from "./LockUnlockedIcon";
import { LockUnlockedFillIcon } from "./LockUnlockedFillIcon";
import { LogoAfterpayIcon } from "./LogoAfterpayIcon";
import { LogoBtcIcon } from "./LogoBtcIcon";
import { LogoEurIcon } from "./LogoEurIcon";
import { LogoGbpIcon } from "./LogoGbpIcon";
import { LogoSquareIcon } from "./LogoSquareIcon";
import { LogoUsdIcon } from "./LogoUsdIcon";
import { LogOutIcon } from "./LogOutIcon";
import { MagicIcon } from "./MagicIcon";
import { MapIcon } from "./MapIcon";
import { MedicalExpenseIcon } from "./MedicalExpenseIcon";
import { MovingExpenseIcon } from "./MovingExpenseIcon";
import { MutualFriendIcon } from "./MutualFriendIcon";
import { NavAddIcon } from "./NavAddIcon";
import { NavCloseIcon } from "./NavCloseIcon";
import { NavigationAccountIcon } from "./NavigationAccountIcon";
import { NavigationActivityIcon } from "./NavigationActivityIcon";
import { NavigationBackIcon } from "./NavigationBackIcon";
import { NavigationBitcoinIcon } from "./NavigationBitcoinIcon";
import { NavigationCardIcon } from "./NavigationCardIcon";
import { NavigationCloseIcon } from "./NavigationCloseIcon";
import { NavigationDiscoverIcon } from "./NavigationDiscoverIcon";
import { NavigationFavoriteIcon } from "./NavigationFavoriteIcon";
import { NavigationFavoriteActiveIcon } from "./NavigationFavoriteActiveIcon";
import { NavigationFilterIcon } from "./NavigationFilterIcon";
import { NavigationFlashOffIcon } from "./NavigationFlashOffIcon";
import { NavigationFlashOnIcon } from "./NavigationFlashOnIcon";
import { NavigationHelpIcon } from "./NavigationHelpIcon";
import { NavigationInternationalP2PIcon } from "./NavigationInternationalP2PIcon";
import { NavigationLogoEurIcon } from "./NavigationLogoEurIcon";
import { NavigationLogoGbpIcon } from "./NavigationLogoGbpIcon";
import { NavigationLogoUsdIcon } from "./NavigationLogoUsdIcon";
import { NavigationMoneyIcon } from "./NavigationMoneyIcon";
import { NavigationMoreIcon } from "./NavigationMoreIcon";
import { NavigationNotificationsIcon } from "./NavigationNotificationsIcon";
import { NavigationOffersIcon } from "./NavigationOffersIcon";
import { NavigationPopBackIcon } from "./NavigationPopBackIcon";
import { NavigationPopForwardIcon } from "./NavigationPopForwardIcon";
import { NavigationRefreshIcon } from "./NavigationRefreshIcon";
import { NavigationScanQrIcon } from "./NavigationScanQrIcon";
import { NavigationSendIcon } from "./NavigationSendIcon";
import { NavigationShareAndroidIcon } from "./NavigationShareAndroidIcon";
import { NavigationShareIosIcon } from "./NavigationShareIosIcon";
import { NavigationShoppingAfterpayIcon } from "./NavigationShoppingAfterpayIcon";
import { NewChatIcon } from "./NewChatIcon";
import { NextIcon } from "./NextIcon";
import { NoCreditCheckIcon } from "./NoCreditCheckIcon";
import { NoteIcon } from "./NoteIcon";
import { NotificationsIcon } from "./NotificationsIcon";
import { NotificationsFillIcon } from "./NotificationsFillIcon";
import { NumberPadIcon } from "./NumberPadIcon";
import { OfficeExpenseIcon } from "./OfficeExpenseIcon";
import { OverdraftProtectionIcon } from "./OverdraftProtectionIcon";
import { PackageReturnIcon } from "./PackageReturnIcon";
import { PackageTrackingIcon } from "./PackageTrackingIcon";
import { PasscodeIcon } from "./PasscodeIcon";
import { PasscodeFillIcon } from "./PasscodeFillIcon";
import { PasskeyIcon } from "./PasskeyIcon";
import { PasswordIcon } from "./PasswordIcon";
import { PaychecksIcon } from "./PaychecksIcon";
import { PayInFourIcon } from "./PayInFourIcon";
import { PayLaterIcon } from "./PayLaterIcon";
import { PendingIcon } from "./PendingIcon";
import { PendingFillIcon } from "./PendingFillIcon";
import { PersonalizedPaymentsIcon } from "./PersonalizedPaymentsIcon";
import { PhotoIcon } from "./PhotoIcon";
import { PickUpIcon } from "./PickUpIcon";
import { PiggyBankUsaIcon } from "./PiggyBankUsaIcon";
import { PinchIcon } from "./PinchIcon";
import { PoolsIcon } from "./PoolsIcon";
import { PrinterIcon } from "./PrinterIcon";
import { PushIcon } from "./PushIcon";
import { PushCenteredIcon } from "./PushCenteredIcon";
import { QrIcon } from "./QrIcon";
import { RecenterIcon } from "./RecenterIcon";
import { RecurringAutomaticIcon } from "./RecurringAutomaticIcon";
import { RefreshIcon } from "./RefreshIcon";
import { RefundedIcon } from "./RefundedIcon";
import { RemittancesIcon } from "./RemittancesIcon";
import { ReorientIcon } from "./ReorientIcon";
import { ReplyIcon } from "./ReplyIcon";
import { RetirementBoatIcon } from "./RetirementBoatIcon";
import { RoundUpsIcon } from "./RoundUpsIcon";
import { SavingsIcon } from "./SavingsIcon";
import { SavingsApyIcon } from "./SavingsApyIcon";
import { SavingsGoalIcon } from "./SavingsGoalIcon";
import { ScrubberIcon } from "./ScrubberIcon";
import { SearchIcon } from "./SearchIcon";
import { SecurityAlertFillIcon } from "./SecurityAlertFillIcon";
import { SecurityAlertOutlineIcon } from "./SecurityAlertOutlineIcon";
import { SecurityCheckFillIcon } from "./SecurityCheckFillIcon";
import { SecurityCheckOutlineIcon } from "./SecurityCheckOutlineIcon";
import { SecurityLockFillIcon } from "./SecurityLockFillIcon";
import { SecurityLockOutlineIcon } from "./SecurityLockOutlineIcon";
import { SelfEmployedIcon } from "./SelfEmployedIcon";
import { SendIcon } from "./SendIcon";
import { SendArrowIcon } from "./SendArrowIcon";
import { SensitiveHiddenIcon } from "./SensitiveHiddenIcon";
import { SensitiveVisibleIcon } from "./SensitiveVisibleIcon";
import { SettingsIcon } from "./SettingsIcon";
import { ShareIcon } from "./ShareIcon";
import { ShareAndroidIcon } from "./ShareAndroidIcon";
import { ShopInStoreIcon } from "./ShopInStoreIcon";
import { ShoppingBagIcon } from "./ShoppingBagIcon";
import { ShoppingCartIcon } from "./ShoppingCartIcon";
import { SkippedIcon } from "./SkippedIcon";
import { StarCircledIcon } from "./StarCircledIcon";
import { StickersIcon } from "./StickersIcon";
import { StopIcon } from "./StopIcon";
import { StudentIcon } from "./StudentIcon";
import { SubtleExpandIcon } from "./SubtleExpandIcon";
import { SubtleMoreIcon } from "./SubtleMoreIcon";
import { SubtlePushIcon } from "./SubtlePushIcon";
import { SubtractIcon } from "./SubtractIcon";
import { SubtractFillIcon } from "./SubtractFillIcon";
import { SubtractOutlineIcon } from "./SubtractOutlineIcon";
import { SupportFillIcon } from "./SupportFillIcon";
import { SwapCurrencyIcon } from "./SwapCurrencyIcon";
import { SwitcherIcon } from "./SwitcherIcon";
import { TapToPayIcon } from "./TapToPayIcon";
import { TaxesIcon } from "./TaxesIcon";
import { TeachingExpenseIcon } from "./TeachingExpenseIcon";
import { TextIcon } from "./TextIcon";
import { ThemesIcon } from "./ThemesIcon";
import { ThumbsDownIcon } from "./ThumbsDownIcon";
import { ThumbsUpIcon } from "./ThumbsUpIcon";
import { TickerDownIcon } from "./TickerDownIcon";
import { TickerUpIcon } from "./TickerUpIcon";
import { TimeIcon } from "./TimeIcon";
import { TimeFillIcon } from "./TimeFillIcon";
import { TimeHourglassIcon } from "./TimeHourglassIcon";
import { TimeInfiniteIcon } from "./TimeInfiniteIcon";
import { TimeProgressStartIcon } from "./TimeProgressStartIcon";
import { TimeStopwatchIcon } from "./TimeStopwatchIcon";
import { TrafficIcon } from "./TrafficIcon";
import { TransferP2PIcon } from "./TransferP2PIcon";
import { TransferWireIcon } from "./TransferWireIcon";
import { UndoIcon } from "./UndoIcon";
import { UptrendIcon } from "./UptrendIcon";
import { VigationChatHistoryIcon } from "./VigationChatHistoryIcon";
import { VigationCopyIcon } from "./VigationCopyIcon";
import { VigationLocalIcon } from "./VigationLocalIcon";
import { VigationMenuAfterpayIcon } from "./VigationMenuAfterpayIcon";
import { VigationMoneybotIcon } from "./VigationMoneybotIcon";
import { VigationMoneybotAltIcon } from "./VigationMoneybotAltIcon";
import { VigationNewChatIcon } from "./VigationNewChatIcon";
import { WalletIcon } from "./WalletIcon";
import { WalletFillIcon } from "./WalletFillIcon";
import { ZeroIcon } from "./ZeroIcon";
export const iconIdMapping = {
  "kxAiAc": { Icon: AccountVerifiedIcon, size: 16 },
  "BMMa7E": { Icon: AccountVerifiedIcon, size: 24 },
  "IchsNG": { Icon: AccountVerifiedIcon, size: 32 },
  "59hbSz": { Icon: AddIcon, size: 16 },
  "Dcz3yj": { Icon: AddIcon, size: 24 },
  "EqQl08": { Icon: AddIcon, size: 32 },
  "IMywDl": { Icon: AddFillIcon, size: 16 },
  "h1PY6q": { Icon: AddFillIcon, size: 24 },
  "Lpq3ZY": { Icon: AfterpayHomeIcon, size: 24 },
  "jttK4G": { Icon: AfterpayMerchantsIcon, size: 24 },
  "tRJa1k": { Icon: AlertIcon, size: 16 },
  "ODO3AU": { Icon: AlertIcon, size: 24 },
  "aKVBAL": { Icon: AlertIcon, size: 32 },
  "M1rhPp": { Icon: AlertFillIcon, size: 16 },
  "cDJl7A": { Icon: AlertFillIcon, size: 24 },
  "u0EPzn": { Icon: AlertFillIcon, size: 32 },
  "EDXqFv": { Icon: AlertOfflineIcon, size: 16 },
  "VQCWB7": { Icon: AlertOfflineIcon, size: 24 },
  "egJfrI": { Icon: AlertOfflineIcon, size: 32 },
  "4kYlj2": { Icon: AlertOnlineIcon, size: 24 },
  "4QpADf": { Icon: AlertOnlineIcon, size: 32 },
  "eFEhXg": { Icon: AlertOnlineIcon, size: 16 },
  "CQaZV4": { Icon: AlertOutlineIcon, size: 16 },
  "jdlgXl": { Icon: AlertOutlineIcon, size: 24 },
  "gcLeSz": { Icon: AlertOutlineIcon, size: 32 },
  "xWpiH9": { Icon: AlertReportedFillIcon, size: 16 },
  "XknEcS": { Icon: AlertReportedFillIcon, size: 24 },
  "jJTbRG": { Icon: AlertReportedFillIcon, size: 32 },
  "HzXa2X": { Icon: AnniversaryIcon, size: 16 },
  "gfV2xP": { Icon: AnniversaryIcon, size: 24 },
  "GpMI8l": { Icon: AnniversaryFillIcon, size: 16 },
  "yw7WZa": { Icon: AnniversaryFillIcon, size: 24 },
  "K7oDr8": { Icon: AnniversaryFillIcon, size: 32 },
  "NKiPf6": { Icon: AtmIcon, size: 16 },
  "pTz4Kf": { Icon: AtmIcon, size: 24 },
  "KeueQN": { Icon: AtmIcon, size: 32 },
  "u5Xd81": { Icon: AtmFillIcon, size: 16 },
  "rX7zTC": { Icon: AtmFillIcon, size: 24 },
  "Ra6VDT": { Icon: AtmFillIcon, size: 32 },
  "BdIV4c": { Icon: AttachIcon, size: 16 },
  "s12csD": { Icon: AttachIcon, size: 24 },
  "wMlwUQ": { Icon: AttachIcon, size: 32 },
  "uw1XBm": { Icon: AvatarIcon, size: 16 },
  "wpp7Tp": { Icon: AvatarIcon, size: 24 },
  "OdYkdS": { Icon: AvatarIcon, size: 32 },
  "fjdi68": { Icon: AvatarFillIcon, size: 16 },
  "KfLpqh": { Icon: AvatarFillIcon, size: 24 },
  "bdH0Yu": { Icon: AvatarFillIcon, size: 32 },
  "nCmd65": { Icon: BackCenteredIcon, size: 24 },
  "jRNNcD": { Icon: BalanceIcon, size: 24 },
  "IyH4ic": { Icon: BankAccountIcon, size: 16 },
  "GXcvqM": { Icon: BankAccountIcon, size: 24 },
  "QmFsqg": { Icon: BankAccountIcon, size: 32 },
  "0z3NKO": { Icon: BankLinkedIcon, size: 16 },
  "Sf5x0o": { Icon: BankLinkedIcon, size: 24 },
  "NiiLjh": { Icon: BankLinkedIcon, size: 32 },
  "K1tRsy": { Icon: BillsIcon, size: 24 },
  "U3zccJ": { Icon: BillsIcon, size: 32 },
  "JAxq4d": { Icon: BillsIcon, size: 16 },
  "09rn7a": { Icon: BiometricsFaceIcon, size: 16 },
  "3h10ev": { Icon: BiometricsFaceIcon, size: 24 },
  "e3wBH4": { Icon: BiometricsFaceIcon, size: 32 },
  "yfphtl": { Icon: BiometricsFingerprintIcon, size: 16 },
  "OZso3t": { Icon: BiometricsFingerprintIcon, size: 24 },
  "8emsdH": { Icon: BiometricsFingerprintIcon, size: 32 },
  "s3xNeE": { Icon: BitcoinLightningIcon, size: 16 },
  "QApIYM": { Icon: BitcoinLightningIcon, size: 24 },
  "RsxZeV": { Icon: BitcoinLightningIcon, size: 32 },
  "45tQF6": { Icon: BlockIcon, size: 16 },
  "yO80IX": { Icon: BlockIcon, size: 24 },
  "5t1bxQ": { Icon: BlockIcon, size: 32 },
  "HkOP1Y": { Icon: BorrowIcon, size: 16 },
  "mS76yZ": { Icon: BorrowIcon, size: 24 },
  "MfukdD": { Icon: BorrowIcon, size: 32 },
  "5TS8FO": { Icon: BotMicIcon, size: 16 },
  "4OGpxx": { Icon: BPayIcon, size: 24 },
  "nmJ33g": { Icon: BulletGenericIcon, size: 16 },
  "pVAi0k": { Icon: BulletGenericIcon, size: 24 },
  "3MJkUa": { Icon: BundleSafeIcon, size: 32 },
  "WFxZGW": { Icon: BundleSafeIcon, size: 24 },
  "Z9CNZl": { Icon: BundleSteadyIcon, size: 32 },
  "qbiFsL": { Icon: BundleSteadyIcon, size: 24 },
  "2k5923": { Icon: BundleWealthIcon, size: 32 },
  "CYN3jo": { Icon: BundleWealthIcon, size: 24 },
  "O8Arvy": { Icon: BusinessIcon, size: 24 },
  "2gcW2d": { Icon: BusinessIcon, size: 16 },
  "A4ldjM": { Icon: BusinessIcon, size: 32 },
  "nvn7pS": { Icon: BusinessEarningsIcon, size: 24 },
  "iIdAmF": { Icon: BusinessEarningsIcon, size: 32 },
  "Iagrwo": { Icon: BusinessEarningsIcon, size: 16 },
  "YX6Uoq": { Icon: BusinessInformativeIcon, size: 24 },
  "jOvnWH": { Icon: CameraFillIcon, size: 16 },
  "WqjGn7": { Icon: CameraFillIcon, size: 24 },
  "7o4Tiu": { Icon: CameraFillIcon, size: 32 },
  "Mp63vT": { Icon: CardActiveIcon, size: 16 },
  "ge3mJU": { Icon: CardActiveIcon, size: 24 },
  "L4dBuH": { Icon: CardActiveIcon, size: 32 },
  "1KRPZC": { Icon: CardAddIcon, size: 16 },
  "u2kSaY": { Icon: CardAddIcon, size: 24 },
  "Pqb2jh": { Icon: CardAddIcon, size: 32 },
  "hUbtt3": { Icon: CardAfterpayIcon, size: 24 },
  "W2GfeV": { Icon: CardBasicIcon, size: 16 },
  "JBpEJg": { Icon: CardBasicIcon, size: 24 },
  "jSGGY9": { Icon: CardBasicIcon, size: 32 },
  "lXMGYo": { Icon: CardBasicFillIcon, size: 16 },
  "YXfE6c": { Icon: CardBasicFillIcon, size: 24 },
  "sOYbjp": { Icon: CardBasicFillIcon, size: 32 },
  "Y5acgN": { Icon: CardCreditIcon, size: 24 },
  "cQrgBu": { Icon: CardCreditIcon, size: 32 },
  "lRBVCg": { Icon: CardDesignIcon, size: 24 },
  "on371v": { Icon: CardDesignIcon, size: 16 },
  "VC8Uu5": { Icon: CardDesignFillIcon, size: 16 },
  "QkPlAb": { Icon: CardDesignFillIcon, size: 24 },
  "FpJ9wF": { Icon: CardDesignFillIcon, size: 32 },
  "Z7styN": { Icon: CardInactiveIcon, size: 16 },
  "ctOLPR": { Icon: CardInactiveIcon, size: 24 },
  "1WSxzc": { Icon: CardInactiveIcon, size: 32 },
  "YfuCHc": { Icon: CardNewIcon, size: 16 },
  "y1gaHS": { Icon: CardNewIcon, size: 24 },
  "pmD2o5": { Icon: CardNewIcon, size: 32 },
  "lGgQPn": { Icon: CardRefreshIcon, size: 24 },
  "KYPDXv": { Icon: CardStripIcon, size: 16 },
  "ueUsQA": { Icon: CardStripIcon, size: 24 },
  "TLu7z5": { Icon: CardStripIcon, size: 32 },
  "FIwWLN": { Icon: CardSupportIcon, size: 16 },
  "SZRY2S": { Icon: CardSupportIcon, size: 24 },
  "5b3I1p": { Icon: CaretDownIcon, size: 16 },
  "D2pNCd": { Icon: CaretUpIcon, size: 16 },
  "xbBlyh": { Icon: CashAppCustomerIcon, size: 16 },
  "jP0N4I": { Icon: CashAppPayIcon, size: 16 },
  "MZfDEC": { Icon: CashAppPayIcon, size: 24 },
  "m5z2xY": { Icon: CashAppPayIcon, size: 32 },
  "W31wnc": { Icon: CategoryAccessoriesIcon, size: 24 },
  "ICDpF5": { Icon: CategoryAccessoriesIcon, size: 32 },
  "QB3H9o": { Icon: CategoryAccessoriesIcon, size: 16 },
  "U4bTpu": { Icon: CategoryAccessoriesAltIcon, size: 24 },
  "79D5PB": { Icon: CategoryAccessoriesHatsIcon, size: 24 },
  "GgYpke": { Icon: CategoryAdultIcon, size: 24 },
  "KKUlmv": { Icon: CategoryApparelIcon, size: 24 },
  "eZ39tA": { Icon: CategoryApparelIcon, size: 32 },
  "yKPRRw": { Icon: CategoryApparelIcon, size: 16 },
  "hHozBN": { Icon: CategoryApparelAltIcon, size: 24 },
  "Z8PZyz": { Icon: CategoryAutoIcon, size: 24 },
  "sKR7HV": { Icon: CategoryAutoIcon, size: 32 },
  "bFuV5Y": { Icon: CategoryAutoIcon, size: 16 },
  "qoWTNb": { Icon: CategoryBarIcon, size: 16 },
  "pr0ayS": { Icon: CategoryBarIcon, size: 24 },
  "64dNkx": { Icon: CategoryBarIcon, size: 32 },
  "geL5up": { Icon: CategoryBusinessServicesIcon, size: 16 },
  "2YeeiH": { Icon: CategoryBusinessServicesIcon, size: 24 },
  "0SgsAQ": { Icon: CategoryBusinessServicesIcon, size: 32 },
  "YpI59C": { Icon: CategoryCafeIcon, size: 16 },
  "YRUotZ": { Icon: CategoryCafeIcon, size: 24 },
  "2OtG8x": { Icon: CategoryCafeIcon, size: 32 },
  "m17gMU": { Icon: CategoryCoffeeIcon, size: 32 },
  "mOk2sq": { Icon: CategoryCoffeeIcon, size: 24 },
  "KRtf7i": { Icon: CategoryCoffeeIcon, size: 16 },
  "BiB43w": { Icon: CategoryDepartmentStoreIcon, size: 24 },
  "lmd9fw": { Icon: CategoryDesignerIcon, size: 24 },
  "w634MN": { Icon: CategoryDiyIcon, size: 24 },
  "CiJp10": { Icon: CategoryEnergyIcon, size: 16 },
  "UWKTFE": { Icon: CategoryEnergyIcon, size: 24 },
  "HUgbkI": { Icon: CategoryEnergyIcon, size: 32 },
  "QCqIHU": { Icon: CategoryEntertainmentIcon, size: 24 },
  "D6AekY": { Icon: CategoryEntertainmentIcon, size: 32 },
  "OM5Zn3": { Icon: CategoryEntertainmentIcon, size: 16 },
  "04oKfB": { Icon: CategoryEtfIcon, size: 16 },
  "Qp5VkQ": { Icon: CategoryEtfIcon, size: 24 },
  "LEjsDE": { Icon: CategoryEtfIcon, size: 32 },
  "LoBM2Y": { Icon: CategoryExperiencesIcon, size: 24 },
  "oWKRHD": { Icon: CategoryFashionIcon, size: 24 },
  "ye1ojU": { Icon: CategoryFastFoodIcon, size: 16 },
  "SQfoP1": { Icon: CategoryFastFoodIcon, size: 24 },
  "IU6upv": { Icon: CategoryFastFoodIcon, size: 32 },
  "BRQbyv": { Icon: CategoryFinanceIcon, size: 16 },
  "Dhx8RH": { Icon: CategoryFinanceIcon, size: 24 },
  "Q5qI2A": { Icon: CategoryFinanceIcon, size: 32 },
  "swKGW6": { Icon: CategoryFitnessIcon, size: 16 },
  "hiOeFf": { Icon: CategoryFitnessIcon, size: 24 },
  "pyBCu8": { Icon: CategoryFitnessIcon, size: 32 },
  "gTetIj": { Icon: CategoryFoodDrinkIcon, size: 24 },
  "JrvOR7": { Icon: CategoryFoodDrinkIcon, size: 32 },
  "Kh3kLV": { Icon: CategoryFoodDrinkIcon, size: 16 },
  "dD3apj": { Icon: CategoryFoodDrinkAltIcon, size: 16 },
  "orlahd": { Icon: CategoryFoodDrinkAltIcon, size: 24 },
  "xvxcpU": { Icon: CategoryFoodDrinkAltIcon, size: 32 },
  "9T6Ci4": { Icon: CategoryFragrancesIcon, size: 24 },
  "ZqNTv0": { Icon: CategoryFurnitureIcon, size: 24 },
  "eRBrqm": { Icon: CategoryGardenIcon, size: 24 },
  "HGJWhT": { Icon: CategoryGasStationIcon, size: 16 },
  "SN00tL": { Icon: CategoryGasStationIcon, size: 24 },
  "6L6w0V": { Icon: CategoryGroceryIcon, size: 24 },
  "v4lOeT": { Icon: CategoryGroceryIcon, size: 32 },
  "4E7p3F": { Icon: CategoryGroceryIcon, size: 16 },
  "MOnEcU": { Icon: CategoryHandbagsIcon, size: 24 },
  "Q3ReoH": { Icon: CategoryHardwareIcon, size: 16 },
  "KPmjDM": { Icon: CategoryHardwareIcon, size: 24 },
  "eYdo5Z": { Icon: CategoryHardwareIcon, size: 32 },
  "KOD7RP": { Icon: CategoryHealthBeautyIcon, size: 24 },
  "MDbiFh": { Icon: CategoryHealthBeautyIcon, size: 32 },
  "UaYxlI": { Icon: CategoryHealthBeautyIcon, size: 16 },
  "zR5qZn": { Icon: CategoryHealthMedicalIcon, size: 16 },
  "25KYho": { Icon: CategoryHealthMedicalIcon, size: 24 },
  "ca5RBo": { Icon: CategoryHealthMedicalIcon, size: 32 },
  "rgVJTf": { Icon: CategoryHomeIcon, size: 24 },
  "nEMksQ": { Icon: CategoryHomeAutoIcon, size: 24 },
  "RU1rE6": { Icon: CategoryHomeAutoIcon, size: 32 },
  "atZH8U": { Icon: CategoryHomeAutoIcon, size: 16 },
  "pQUbZe": { Icon: CategoryHotelIcon, size: 16 },
  "xZDN0f": { Icon: CategoryHotelIcon, size: 24 },
  "c35MJL": { Icon: CategoryHotelIcon, size: 32 },
  "tO6mCC": { Icon: CategoryIpoIcon, size: 16 },
  "NmtN1G": { Icon: CategoryIpoIcon, size: 24 },
  "9UYMkG": { Icon: CategoryIpoIcon, size: 32 },
  "trklmA": { Icon: CategoryJewelryIcon, size: 24 },
  "xCNWIa": { Icon: CategoryKidsIcon, size: 24 },
  "BBROsv": { Icon: CategoryMediaIcon, size: 16 },
  "2iAXQa": { Icon: CategoryMediaIcon, size: 24 },
  "A6ZXBn": { Icon: CategoryMediaIcon, size: 32 },
  "wD7mvq": { Icon: CategoryMovingIcon, size: 16 },
  "luSDue": { Icon: CategoryMovingIcon, size: 24 },
  "1W9ktX": { Icon: CategoryMovingIcon, size: 32 },
  "wa9Ezz": { Icon: CategoryOnlineIcon, size: 16 },
  "qL2JwG": { Icon: CategoryOnlineIcon, size: 24 },
  "zciwL7": { Icon: CategoryOnlineIcon, size: 32 },
  "IRvR2U": { Icon: CategoryPetStoreIcon, size: 16 },
  "x3uL40": { Icon: CategoryPetStoreIcon, size: 24 },
  "TKl2nW": { Icon: CategoryPetStoreIcon, size: 32 },
  "fHHcrY": { Icon: CategoryPharmacyIcon, size: 16 },
  "Mq6z6j": { Icon: CategoryPharmacyIcon, size: 24 },
  "WqxtNn": { Icon: CategoryPharmacyIcon, size: 32 },
  "J27idV": { Icon: CategoryPopularIcon, size: 24 },
  "p8ZtLM": { Icon: CategoryRentIcon, size: 24 },
  "iERu1p": { Icon: CategoryRentIcon, size: 32 },
  "fUBT20": { Icon: CategoryRentIcon, size: 16 },
  "flJLDS": { Icon: CategoryRestaurantIcon, size: 32 },
  "WaF3JJ": { Icon: CategoryRestaurantIcon, size: 24 },
  "Qsx6R0": { Icon: CategoryRestaurantIcon, size: 16 },
  "uHZGas": { Icon: CategoryShoesIcon, size: 24 },
  "EQ5OqF": { Icon: CategoryShoesIcon, size: 32 },
  "6aQvqO": { Icon: CategoryShoesIcon, size: 16 },
  "J2VAxO": { Icon: CategoryShoesAltIcon, size: 24 },
  "9Kw9M6": { Icon: CategoryShoesHeelIcon, size: 24 },
  "n1ZlVz": { Icon: CategoryShoppingIcon, size: 16 },
  "hHNL8H": { Icon: CategoryShoppingIcon, size: 24 },
  "tlqlVc": { Icon: CategoryShoppingIcon, size: 32 },
  "bhIf5v": { Icon: CategoryShoppingAltIcon, size: 16 },
  "wZSjVJ": { Icon: CategoryShoppingAltIcon, size: 24 },
  "draWIy": { Icon: CategoryShoppingAltIcon, size: 32 },
  "5jd9Mo": { Icon: CategoryShoppingCenterIcon, size: 24 },
  "3noGOv": { Icon: CategorySportsIcon, size: 16 },
  "2LCcdr": { Icon: CategorySportsIcon, size: 24 },
  "huCTp3": { Icon: CategorySportsIcon, size: 32 },
  "zfgLzk": { Icon: CategorySportsAltIcon, size: 24 },
  "QPvamT": { Icon: CategoryTechIcon, size: 24 },
  "eItoVO": { Icon: CategoryTechnologyIcon, size: 16 },
  "jY6Kb2": { Icon: CategoryTechnologyIcon, size: 24 },
  "50FbFg": { Icon: CategoryTechnologyIcon, size: 32 },
  "54JBWT": { Icon: CategoryTourismIcon, size: 16 },
  "P2LE3b": { Icon: CategoryTourismIcon, size: 24 },
  "F0thcY": { Icon: CategoryTourismIcon, size: 32 },
  "aqT77q": { Icon: CategoryToysIcon, size: 24 },
  "01LetR": { Icon: CategoryTransporationAltIcon, size: 24 },
  "x4ZklY": { Icon: CategoryTransporationAltIcon, size: 32 },
  "nSvhR2": { Icon: CategoryTransportationIcon, size: 16 },
  "4Nijia": { Icon: CategoryTransportationIcon, size: 24 },
  "eHvYjq": { Icon: CategoryTransportationIcon, size: 32 },
  "0d37dr": { Icon: CategoryTravelIcon, size: 24 },
  "QzuTty": { Icon: CategoryTravelIcon, size: 32 },
  "uOsEzB": { Icon: CategoryTravelIcon, size: 16 },
  "7A2A2p": { Icon: CategoryUtilitiesIcon, size: 24 },
  "sYOezM": { Icon: CategoryUtilitiesIcon, size: 32 },
  "pQDgGE": { Icon: CategoryUtilitiesIcon, size: 16 },
  "8O9gEP": { Icon: CharityIcon, size: 24 },
  "1m6Xmv": { Icon: ChatActiveIcon, size: 24 },
  "T4Yn0f": { Icon: ChatSmartIcon, size: 24 },
  "cfdYYz": { Icon: CheckIcon, size: 16 },
  "YVnxSd": { Icon: CheckIcon, size: 24 },
  "BCuf7u": { Icon: CheckIcon, size: 32 },
  "rPLszq": { Icon: CheckFillIcon, size: 16 },
  "pfbkAI": { Icon: CheckFillIcon, size: 24 },
  "JHkvDy": { Icon: CheckOutlineIcon, size: 16 },
  "yNIzz6": { Icon: ClearIcon, size: 16 },
  "a7RvR6": { Icon: ClearIcon, size: 24 },
  "tKY2la": { Icon: ClearIcon, size: 32 },
  "yVFZCs": { Icon: ClearFieldIcon, size: 24 },
  "wTm6IN": { Icon: CoinsIcon, size: 24 },
  "a3XPgp": { Icon: CollapseIcon, size: 24 },
  "CX8ieX": { Icon: CollapseCenteredIcon, size: 24 },
  "iPhAXD": { Icon: CommChatIcon, size: 16 },
  "YL25Z2": { Icon: CommChatIcon, size: 24 },
  "Nkf6zQ": { Icon: CommEmailIcon, size: 16 },
  "KHLFjx": { Icon: CommEmailIcon, size: 24 },
  "7GcBOI": { Icon: CommEmailIcon, size: 32 },
  "frNkXc": { Icon: CommEmailFillIcon, size: 16 },
  "FXjyuz": { Icon: CommEmailFillIcon, size: 24 },
  "51drIH": { Icon: CommEmailFillIcon, size: 32 },
  "DQaqLl": { Icon: CommPhoneFillIcon, size: 16 },
  "v6iNHH": { Icon: CommPhoneFillIcon, size: 24 },
  "NIoyWL": { Icon: CommPhoneFillIcon, size: 32 },
  "FkkTFh": { Icon: CommSmsIcon, size: 16 },
  "HbPGus": { Icon: CommSmsIcon, size: 24 },
  "CoBHTi": { Icon: CommSmsIcon, size: 32 },
  "DbhJl0": { Icon: CommSmsFillIcon, size: 16 },
  "VXQnYl": { Icon: CommSmsFillIcon, size: 24 },
  "FWKJcJ": { Icon: CommSmsFillIcon, size: 32 },
  "aGVEzj": { Icon: ContactAddIcon, size: 16 },
  "5I2jrj": { Icon: ContactAddIcon, size: 32 },
  "ejsIR4": { Icon: ContactAddIcon, size: 24 },
  "mqzsBl": { Icon: ContactFalseIcon, size: 24 },
  "UV3W6x": { Icon: ContactFalseIcon, size: 16 },
  "FpDJiD": { Icon: ContactTrueIcon, size: 16 },
  "rXAeTa": { Icon: ContactTrueIcon, size: 24 },
  "bf2Cfe": { Icon: ContactTrueIcon, size: 32 },
  "9Xcg2d": { Icon: ControlIcon, size: 16 },
  "eW3QMQ": { Icon: ControlIcon, size: 24 },
  "g7EnPA": { Icon: CopyIcon, size: 16 },
  "IoU1tO": { Icon: CopyIcon, size: 24 },
  "DDsHb5": { Icon: CopyIcon, size: 32 },
  "AjkpOk": { Icon: CurrencyBtcIcon, size: 16 },
  "FF9MIq": { Icon: CurrencyBtcIcon, size: 24 },
  "t2gUGd": { Icon: CurrencyBtcIcon, size: 32 },
  "fYXtyS": { Icon: CurrencyEurIcon, size: 16 },
  "0xo9W9": { Icon: CurrencyEurIcon, size: 24 },
  "6vyDpN": { Icon: CurrencyEurIcon, size: 32 },
  "ChbmeJ": { Icon: CurrencyGbpIcon, size: 16 },
  "NKokgi": { Icon: CurrencyGbpIcon, size: 24 },
  "3HAuI3": { Icon: CurrencyGbpIcon, size: 32 },
  "OBfBkg": { Icon: CurrencyUsdIcon, size: 16 },
  "dOc3m0": { Icon: CurrencyUsdIcon, size: 24 },
  "XPs2yy": { Icon: CurrencyUsdIcon, size: 32 },
  "BdefhU": { Icon: CustomizeBrushFillIcon, size: 16 },
  "qBa6ia": { Icon: CustomizeBrushFillIcon, size: 24 },
  "X8pY0O": { Icon: CustomizeBrushFillIcon, size: 32 },
  "7IlAJw": { Icon: DataIcon, size: 24 },
  "z0zjeQ": { Icon: DateIcon, size: 16 },
  "ZYPsui": { Icon: DateIcon, size: 24 },
  "t2ncyw": { Icon: DateIcon, size: 32 },
  "cWCXbW": { Icon: DateStartIcon, size: 24 },
  "f7ky6n": { Icon: DateStopIcon, size: 24 },
  "WIUDmd": { Icon: DeliveryIcon, size: 16 },
  "z4DW9q": { Icon: DeliveryIcon, size: 24 },
  "LAMxeM": { Icon: DeliveryIcon, size: 32 },
  "jpLGYL": { Icon: DepositIcon, size: 16 },
  "LQUx2D": { Icon: DepositIcon, size: 24 },
  "1pViqo": { Icon: DepositIcon, size: 32 },
  "cB5CTK": { Icon: DepositBarcodeIcon, size: 24 },
  "IJxvRm": { Icon: DepositBarcodeIcon, size: 16 },
  "xK4TFs": { Icon: DepositBarcodeIcon, size: 32 },
  "LZqAyI": { Icon: DepositCheckIcon, size: 16 },
  "P1NcbA": { Icon: DepositCheckIcon, size: 24 },
  "rxa1CE": { Icon: DepositCheckIcon, size: 32 },
  "64SHZU": { Icon: DepositPaperIcon, size: 24 },
  "XIKVWT": { Icon: DepositPaperIcon, size: 32 },
  "9F2QXq": { Icon: DeviceDesktopIcon, size: 16 },
  "3WcL89": { Icon: DeviceDesktopIcon, size: 24 },
  "PGDrNF": { Icon: DeviceDesktopIcon, size: 32 },
  "VYR6fS": { Icon: DeviceLaptopIcon, size: 16 },
  "o1zhSD": { Icon: DeviceLaptopIcon, size: 24 },
  "ulRRHw": { Icon: DeviceLaptopIcon, size: 32 },
  "cdymJ4": { Icon: DeviceMobileIcon, size: 16 },
  "YxclJB": { Icon: DeviceMobileIcon, size: 24 },
  "alUrXG": { Icon: DeviceMobileIcon, size: 32 },
  "Kf9xp1": { Icon: DeviceTapIcon, size: 16 },
  "b2TSUf": { Icon: DeviceTapIcon, size: 24 },
  "lEc1Lf": { Icon: DeviceTapIcon, size: 32 },
  "8XkIpW": { Icon: DineInIcon, size: 24 },
  "6fG1V8": { Icon: DiscountMaximumIcon, size: 24 },
  "GKUbvu": { Icon: DiscountMaximumIcon, size: 32 },
  "RfyeYF": { Icon: DiscountMaximumIcon, size: 16 },
  "cnRZxj": { Icon: DiscountMinimumIcon, size: 16 },
  "FpKOav": { Icon: DiscountMinimumIcon, size: 24 },
  "QWYrrE": { Icon: DiscountMinimumIcon, size: 32 },
  "q7k3hI": { Icon: DiscountPercentageIcon, size: 16 },
  "iCAtj0": { Icon: DiscountPercentageIcon, size: 24 },
  "2cazRp": { Icon: DiscountPercentageIcon, size: 32 },
  "B06Lkl": { Icon: DiscountTagIcon, size: 16 },
  "ThsKPh": { Icon: DiscountTagIcon, size: 24 },
  "XZxmqI": { Icon: DiscountTagIcon, size: 32 },
  "zsP3UT": { Icon: DiscountTagFillIcon, size: 16 },
  "Q3XgDB": { Icon: DiscountTagFillIcon, size: 24 },
  "4tPLyL": { Icon: DiscountTagFillIcon, size: 32 },
  "ZmA2it": { Icon: DocumentIcon, size: 16 },
  "ePNbIF": { Icon: DocumentIcon, size: 24 },
  "LFI8uz": { Icon: DocumentIcon, size: 32 },
  "mX7qBf": { Icon: DocumentCertificateIcon, size: 16 },
  "y5jmJZ": { Icon: DocumentCertificateIcon, size: 24 },
  "yoCT7W": { Icon: DocumentCertificateIcon, size: 32 },
  "QHux7p": { Icon: DocumentCourtOrderIcon, size: 16 },
  "QJpSVS": { Icon: DocumentCourtOrderIcon, size: 24 },
  "ya7JoN": { Icon: DocumentCourtOrderIcon, size: 32 },
  "fuuoWu": { Icon: DocumentFillIcon, size: 16 },
  "H26yYE": { Icon: DocumentFillIcon, size: 24 },
  "bsbiYA": { Icon: DocumentFillIcon, size: 32 },
  "lVaWBn": { Icon: DocumentPaystubIcon, size: 16 },
  "EERozn": { Icon: DocumentPaystubIcon, size: 24 },
  "sNnvuY": { Icon: DocumentPaystubIcon, size: 32 },
  "QiZyFw": { Icon: DocumentQuillIcon, size: 16 },
  "yCS83N": { Icon: DocumentQuillIcon, size: 24 },
  "nGBt0C": { Icon: DocumentQuillIcon, size: 32 },
  "ZzR3ga": { Icon: DocumentW2Icon, size: 16 },
  "q2uIeO": { Icon: DocumentW2Icon, size: 24 },
  "U2QTqi": { Icon: DocumentW2Icon, size: 32 },
  "TrsdnP": { Icon: DownloadIcon, size: 16 },
  "iNtYte": { Icon: DownloadIcon, size: 24 },
  "zVqolL": { Icon: DownloadIcon, size: 32 },
  "3ZG16R": { Icon: DowntrendIcon, size: 16 },
  "67MkCU": { Icon: DrawIcon, size: 16 },
  "hieFZ0": { Icon: DrawIcon, size: 24 },
  "mKkEZ3": { Icon: DrawIcon, size: 32 },
  "LgcfvS": { Icon: EditIcon, size: 16 },
  "yWdGay": { Icon: EditIcon, size: 24 },
  "H0JbP4": { Icon: EmployerIcon, size: 24 },
  "OVG63p": { Icon: ExpandIcon, size: 24 },
  "52lBTy": { Icon: ExpandCenteredIcon, size: 24 },
  "FirlgD": { Icon: FailedIcon, size: 16 },
  "VZZRg0": { Icon: FailedIcon, size: 24 },
  "au01l6": { Icon: FailedIcon, size: 32 },
  "myAWkC": { Icon: FailedFillIcon, size: 16 },
  "ZUJTka": { Icon: FailedFillIcon, size: 24 },
  "RTG28D": { Icon: FailedFillIcon, size: 32 },
  "w9DTQ7": { Icon: FailedOutlineIcon, size: 16 },
  "Es34t7": { Icon: FailedOutlineIcon, size: 24 },
  "RV0HYR": { Icon: FailedOutlineIcon, size: 32 },
  "GLkRqZ": { Icon: FamilyIcon, size: 16 },
  "yd6Bf6": { Icon: FamilyIcon, size: 24 },
  "7pSmPI": { Icon: FamilyIcon, size: 32 },
  "TfcgWx": { Icon: FamilyExpenseIcon, size: 24 },
  "5UgLnT": { Icon: FastIcon, size: 16 },
  "MAHps6": { Icon: FastIcon, size: 24 },
  "3F3xUQ": { Icon: FastIcon, size: 32 },
  "EmNgdi": { Icon: FavoriteIcon, size: 16 },
  "Xjy6RJ": { Icon: FavoriteIcon, size: 24 },
  "W9jg3z": { Icon: FavoriteFillIcon, size: 16 },
  "uxKIVG": { Icon: FavoriteFillIcon, size: 24 },
  "PNUY1I": { Icon: FavoriteFillIcon, size: 32 },
  "z2YEhx": { Icon: FdicIcon, size: 16 },
  "Tahnb4": { Icon: FdicIcon, size: 24 },
  "qgR1hM": { Icon: FdicIcon, size: 32 },
  "akzGN6": { Icon: FlashlightFillIcon, size: 16 },
  "diJCst": { Icon: FlashlightFillIcon, size: 24 },
  "XZ1FZ3": { Icon: FlashlightOffFillIcon, size: 24 },
  "TTwfaW": { Icon: FlashOffIcon, size: 16 },
  "SafBon": { Icon: FlashOffIcon, size: 24 },
  "KYKlEm": { Icon: FlashOnIcon, size: 16 },
  "fXPaFl": { Icon: FlashOnIcon, size: 24 },
  "ppq6pr": { Icon: FlashOnIcon, size: 32 },
  "Pzp2W8": { Icon: FlatFeeIcon, size: 24 },
  "lflGqA": { Icon: FpoBurstIcon, size: 32 },
  "bfLzdZ": { Icon: FpoShrimpIcon, size: 16 },
  "C0z7en": { Icon: FpoShrimpIcon, size: 24 },
  "oHKexe": { Icon: FpoShrimpIcon, size: 32 },
  "4u0iaV": { Icon: GiftIcon, size: 24 },
  "3teicR": { Icon: GiftIcon, size: 32 },
  "pvZTEg": { Icon: GiftcardIcon, size: 16 },
  "Bjl15V": { Icon: GiftcardIcon, size: 24 },
  "Yd3lOW": { Icon: GiftcardIcon, size: 32 },
  "0axgtH": { Icon: GooglePayIcon, size: 16 },
  "1pHv0w": { Icon: GooglePayIcon, size: 24 },
  "6PPW87": { Icon: GooglePayIcon, size: 32 },
  "nb5F6q": { Icon: GovernmentFlagIcon, size: 24 },
  "4GRduR": { Icon: GridViewIcon, size: 24 },
  "DGvfPh": { Icon: HandoutIcon, size: 24 },
  "K1Vzpl": { Icon: HashIcon, size: 24 },
  "I0Xb1h": { Icon: HeartbeatIcon, size: 24 },
  "TSBIhZ": { Icon: HelpIcon, size: 24 },
  "F8iQKT": { Icon: HelpIcon, size: 32 },
  "gJGJ46": { Icon: HelpFillIcon, size: 24 },
  "NF0Qqy": { Icon: HelpFillIcon, size: 16 },
  "PVR8vB": { Icon: HelpOutlineIcon, size: 24 },
  "yR5iI4": { Icon: HelpOutlineIcon, size: 16 },
  "nBz2DR": { Icon: HelpSimpleIcon, size: 16 },
  "aFRLix": { Icon: HsaCardIcon, size: 24 },
  "vB0gzZ": { Icon: HyperlinkIcon, size: 16 },
  "oywrej": { Icon: HyperlinkIcon, size: 24 },
  "rEKacS": { Icon: HyperlinkIcon, size: 32 },
  "u8OYeO": { Icon: IdeaIcon, size: 24 },
  "HwTFpN": { Icon: IdGovernmentIcon, size: 16 },
  "GGA1Zv": { Icon: IdGovernmentIcon, size: 24 },
  "XGVjay": { Icon: IdPassportIcon, size: 16 },
  "opwGFb": { Icon: IdPassportIcon, size: 24 },
  "GG9TWS": { Icon: ImageIcon, size: 24 },
  "bdAYGY": { Icon: InformationIcon, size: 16 },
  "NjBUrV": { Icon: InformationIcon, size: 24 },
  "2xm0j0": { Icon: InformationIcon, size: 32 },
  "O13AL3": { Icon: InformationFillIcon, size: 16 },
  "XDLOBz": { Icon: InformationFillIcon, size: 24 },
  "vAJx1x": { Icon: InformationFillIcon, size: 32 },
  "vgB7eh": { Icon: InformationOutlineIcon, size: 16 },
  "ejJmNV": { Icon: InformationOutlineIcon, size: 24 },
  "5kLlS6": { Icon: InformationOutlineIcon, size: 32 },
  "Pcmgzv": { Icon: InsightsIcon, size: 24 },
  "Pl4t0H": { Icon: InsightsIcon, size: 32 },
  "WN4UA5": { Icon: InstantIcon, size: 24 },
  "4BEA8h": { Icon: InstantIcon, size: 16 },
  "L2Ib1M": { Icon: InstantIcon, size: 32 },
  "Ds7b9I": { Icon: InstantFillIcon, size: 16 },
  "9Ko6bA": { Icon: InstantFillIcon, size: 24 },
  "EC7CTF": { Icon: InternationalIcon, size: 16 },
  "FwCSIF": { Icon: InternationalIcon, size: 24 },
  "ynbMOz": { Icon: InternationalIcon, size: 32 },
  "MduPmk": { Icon: InvestingIcon, size: 16 },
  "Yt8kA8": { Icon: InvestingIcon, size: 24 },
  "FF3z6n": { Icon: InvestingIcon, size: 32 },
  "re8v4q": { Icon: InvestingCustomBuyIcon, size: 16 },
  "xOD8SB": { Icon: InvestingCustomBuyIcon, size: 24 },
  "9lGDdg": { Icon: InvestingCustomBuyIcon, size: 32 },
  "0qFakd": { Icon: InvestingCustomSellIcon, size: 24 },
  "xtPPv9": { Icon: IrsPrepaidIcon, size: 24 },
  "gdy0d7": { Icon: KeypadDeleteIcon, size: 24 },
  "QoHqVj": { Icon: LikeIcon, size: 16 },
  "T8vlBz": { Icon: LikeIcon, size: 24 },
  "uJA41X": { Icon: LimitsIcon, size: 16 },
  "Folmsm": { Icon: LimitsIcon, size: 24 },
  "7uGi57": { Icon: LimitsFillIcon, size: 16 },
  "ROyBYF": { Icon: LimitsFillIcon, size: 24 },
  "HHsTCQ": { Icon: LimitsFillIcon, size: 32 },
  "jwtKdr": { Icon: LinkOutIcon, size: 16 },
  "SMpcVe": { Icon: LinkOutIcon, size: 24 },
  "KxpkDn": { Icon: LinkOutIcon, size: 32 },
  "WMfO0X": { Icon: LocalIcon, size: 24 },
  "xdlx3P": { Icon: LocalIcon, size: 16 },
  "RbQxO2": { Icon: LocalIcon, size: 32 },
  "9LDPU1": { Icon: LocationIcon, size: 16 },
  "VAJHPc": { Icon: LocationIcon, size: 24 },
  "tJY9Ka": { Icon: LocationIcon, size: 32 },
  "Y9XLCG": { Icon: LocationDuoIcon, size: 16 },
  "fR3xoF": { Icon: LocationDuoIcon, size: 24 },
  "w7ldjc": { Icon: LocationDuoIcon, size: 32 },
  "Ypg6PU": { Icon: LocationFillIcon, size: 16 },
  "MJBCbn": { Icon: LocationFillIcon, size: 24 },
  "6nhbeG": { Icon: LocationFillIcon, size: 32 },
  "Lhkx07": { Icon: LockLockedIcon, size: 16 },
  "o3Rxtb": { Icon: LockLockedIcon, size: 24 },
  "rFpC3X": { Icon: LockLockedFillIcon, size: 16 },
  "qFw01A": { Icon: LockLockedFillIcon, size: 24 },
  "0Qn48e": { Icon: LockLockedFillIcon, size: 32 },
  "oWSJxU": { Icon: LockUnlockedIcon, size: 16 },
  "htomVU": { Icon: LockUnlockedIcon, size: 24 },
  "qyDgAw": { Icon: LockUnlockedFillIcon, size: 16 },
  "hL82hL": { Icon: LockUnlockedFillIcon, size: 24 },
  "HHUstX": { Icon: LockUnlockedFillIcon, size: 32 },
  "uo9um1": { Icon: LogoAfterpayIcon, size: 24 },
  "u7ypf2": { Icon: LogoAfterpayIcon, size: 16 },
  "u2t7BJ": { Icon: LogoAfterpayIcon, size: 32 },
  "hMLtiP": { Icon: LogoBtcIcon, size: 16 },
  "1hEu9g": { Icon: LogoBtcIcon, size: 24 },
  "Vxg9zR": { Icon: LogoBtcIcon, size: 32 },
  "BMy6C5": { Icon: LogoEurIcon, size: 16 },
  "10E5xf": { Icon: LogoEurIcon, size: 24 },
  "xy0VTM": { Icon: LogoEurIcon, size: 32 },
  "L9Fzqv": { Icon: LogoGbpIcon, size: 16 },
  "zEmz5M": { Icon: LogoGbpIcon, size: 24 },
  "HbBvNi": { Icon: LogoGbpIcon, size: 32 },
  "WGul07": { Icon: LogoSquareIcon, size: 32 },
  "NMB5nw": { Icon: LogoSquareIcon, size: 24 },
  "jXDyUI": { Icon: LogoSquareIcon, size: 16 },
  "Iq9GOk": { Icon: LogoUsdIcon, size: 16 },
  "lL0bto": { Icon: LogoUsdIcon, size: 24 },
  "SpYGHC": { Icon: LogoUsdIcon, size: 32 },
  "Jh57B0": { Icon: LogOutIcon, size: 24 },
  "SeFJtr": { Icon: LogOutIcon, size: 16 },
  "MAGvK7": { Icon: MagicIcon, size: 24 },
  "t6Scb4": { Icon: MagicIcon, size: 32 },
  "cPpVvs": { Icon: MapIcon, size: 24 },
  "8YDpIi": { Icon: MedicalExpenseIcon, size: 24 },
  "4jFgfV": { Icon: MovingExpenseIcon, size: 24 },
  "9GFu36": { Icon: MutualFriendIcon, size: 16 },
  "zPnmZg": { Icon: MutualFriendIcon, size: 24 },
  "2ZduXj": { Icon: MutualFriendIcon, size: 32 },
  "MMSx92": { Icon: NavAddIcon, size: 16 },
  "6pxYIX": { Icon: NavCloseIcon, size: 16 },
  "NOEvnT": { Icon: NavigationAccountIcon, size: 24 },
  "Vo8fvX": { Icon: NavigationActivityIcon, size: 24 },
  "sEkxC2": { Icon: NavigationBackIcon, size: 24 },
  "aFkVXM": { Icon: NavigationBitcoinIcon, size: 24 },
  "XvXH5y": { Icon: NavigationCardIcon, size: 24 },
  "Fh4cHB": { Icon: NavigationCloseIcon, size: 24 },
  "k5hMwl": { Icon: NavigationDiscoverIcon, size: 24 },
  "Fh3v0e": { Icon: NavigationFavoriteIcon, size: 24 },
  "BkOJjI": { Icon: NavigationFavoriteActiveIcon, size: 24 },
  "Vi9Dc6": { Icon: NavigationFilterIcon, size: 24 },
  "UGv2Yo": { Icon: NavigationFlashOffIcon, size: 24 },
  "10wV8k": { Icon: NavigationFlashOnIcon, size: 24 },
  "7pZsFc": { Icon: NavigationHelpIcon, size: 24 },
  "vuEXyC": { Icon: NavigationInternationalP2PIcon, size: 24 },
  "Awsy7U": { Icon: NavigationLogoEurIcon, size: 24 },
  "mJX9K4": { Icon: NavigationLogoGbpIcon, size: 24 },
  "Epe8sc": { Icon: NavigationLogoUsdIcon, size: 24 },
  "l27jTu": { Icon: NavigationMoneyIcon, size: 24 },
  "hziVzO": { Icon: NavigationMoreIcon, size: 24 },
  "KVy3hE": { Icon: NavigationNotificationsIcon, size: 24 },
  "8wbKM0": { Icon: NavigationOffersIcon, size: 24 },
  "me9qAB": { Icon: NavigationPopBackIcon, size: 24 },
  "Cpkrvi": { Icon: NavigationPopForwardIcon, size: 24 },
  "XzEmsv": { Icon: NavigationRefreshIcon, size: 24 },
  "hLu8Rl": { Icon: NavigationScanQrIcon, size: 24 },
  "JKxQE1": { Icon: NavigationSendIcon, size: 24 },
  "cwICE3": { Icon: NavigationShareAndroidIcon, size: 24 },
  "Z31hYP": { Icon: NavigationShareIosIcon, size: 24 },
  "Xmin13": { Icon: NavigationShoppingAfterpayIcon, size: 24 },
  "5eCvSS": { Icon: NewChatIcon, size: 24 },
  "Pzp58t": { Icon: NextIcon, size: 24 },
  "bP1Stt": { Icon: NoCreditCheckIcon, size: 24 },
  "GYq6vj": { Icon: NoteIcon, size: 16 },
  "fMt5vS": { Icon: NoteIcon, size: 24 },
  "9I6blW": { Icon: NoteIcon, size: 32 },
  "v9UvPu": { Icon: NotificationsIcon, size: 16 },
  "nF7cxo": { Icon: NotificationsIcon, size: 24 },
  "Jw2XiJ": { Icon: NotificationsIcon, size: 32 },
  "ag8gLN": { Icon: NotificationsFillIcon, size: 16 },
  "OCDJyG": { Icon: NotificationsFillIcon, size: 24 },
  "UavoeO": { Icon: NotificationsFillIcon, size: 32 },
  "ijoH7j": { Icon: NumberPadIcon, size: 24 },
  "s4HcXt": { Icon: OfficeExpenseIcon, size: 24 },
  "cZbvON": { Icon: OverdraftProtectionIcon, size: 16 },
  "0WpBiM": { Icon: OverdraftProtectionIcon, size: 24 },
  "erH8nz": { Icon: OverdraftProtectionIcon, size: 32 },
  "8qv40b": { Icon: PackageReturnIcon, size: 24 },
  "FEKpj5": { Icon: PackageTrackingIcon, size: 24 },
  "s3IS8c": { Icon: PasscodeIcon, size: 32 },
  "GjTFYh": { Icon: PasscodeFillIcon, size: 16 },
  "bPUudu": { Icon: PasscodeFillIcon, size: 24 },
  "oQ5gWh": { Icon: PasskeyIcon, size: 24 },
  "gCV6jm": { Icon: PasswordIcon, size: 24 },
  "OMyDWK": { Icon: PaychecksIcon, size: 24 },
  "UnAfiG": { Icon: PaychecksIcon, size: 32 },
  "txDTmo": { Icon: PaychecksIcon, size: 16 },
  "KcUT9N": { Icon: PayInFourIcon, size: 32 },
  "g7giOn": { Icon: PayInFourIcon, size: 24 },
  "n5YNcO": { Icon: PayInFourIcon, size: 16 },
  "lrxZ6K": { Icon: PayLaterIcon, size: 32 },
  "uxVj5f": { Icon: PayLaterIcon, size: 24 },
  "HrChFa": { Icon: PayLaterIcon, size: 16 },
  "6GMm3W": { Icon: PendingIcon, size: 16 },
  "ts1Zo2": { Icon: PendingIcon, size: 24 },
  "uteidv": { Icon: PendingIcon, size: 32 },
  "oxgTT8": { Icon: PendingFillIcon, size: 16 },
  "d6nRFB": { Icon: PersonalizedPaymentsIcon, size: 24 },
  "DUCDms": { Icon: PersonalizedPaymentsIcon, size: 16 },
  "0aOD9b": { Icon: PhotoIcon, size: 24 },
  "hsXQH1": { Icon: PickUpIcon, size: 24 },
  "MjFpm9": { Icon: PiggyBankUsaIcon, size: 24 },
  "1iujN1": { Icon: PinchIcon, size: 24 },
  "1rBWY1": { Icon: PoolsIcon, size: 24 },
  "kQJi14": { Icon: PoolsIcon, size: 16 },
  "G02Zyv": { Icon: PoolsIcon, size: 32 },
  "CwSa11": { Icon: PrinterIcon, size: 24 },
  "UnSbnk": { Icon: PushIcon, size: 24 },
  "r3FfcI": { Icon: PushCenteredIcon, size: 24 },
  "OIon4m": { Icon: QrIcon, size: 16 },
  "VRwsDt": { Icon: QrIcon, size: 24 },
  "a8WVXY": { Icon: QrIcon, size: 32 },
  "XvGD5I": { Icon: RecenterIcon, size: 24 },
  "tdmRZp": { Icon: RecurringAutomaticIcon, size: 16 },
  "0IwHcW": { Icon: RecurringAutomaticIcon, size: 24 },
  "3b7nKP": { Icon: RecurringAutomaticIcon, size: 32 },
  "qJpvqR": { Icon: RefreshIcon, size: 24 },
  "lIi28m": { Icon: RefundedIcon, size: 16 },
  "9X5Agz": { Icon: RefundedIcon, size: 24 },
  "HPHwm5": { Icon: RemittancesIcon, size: 24 },
  "DmIcjo": { Icon: RemittancesIcon, size: 32 },
  "0luAA2": { Icon: RemittancesIcon, size: 16 },
  "37kBaZ": { Icon: ReorientIcon, size: 24 },
  "i1liPK": { Icon: ReplyIcon, size: 16 },
  "wSdyol": { Icon: ReplyIcon, size: 24 },
  "XPdEPI": { Icon: RetirementBoatIcon, size: 24 },
  "QD4nyn": { Icon: RoundUpsIcon, size: 16 },
  "hHwc1o": { Icon: RoundUpsIcon, size: 24 },
  "of8Iye": { Icon: RoundUpsIcon, size: 32 },
  "wm8Ter": { Icon: SavingsIcon, size: 16 },
  "rph4y6": { Icon: SavingsIcon, size: 24 },
  "l8uiBj": { Icon: SavingsIcon, size: 32 },
  "vwT7d5": { Icon: SavingsApyIcon, size: 24 },
  "niaC9A": { Icon: SavingsApyIcon, size: 32 },
  "K9cqyL": { Icon: SavingsGoalIcon, size: 24 },
  "uZy37b": { Icon: SavingsGoalIcon, size: 32 },
  "boAmos": { Icon: ScrubberIcon, size: 24 },
  "bDYWJV": { Icon: SearchIcon, size: 16 },
  "KjpOkJ": { Icon: SearchIcon, size: 24 },
  "za6sNS": { Icon: SecurityAlertFillIcon, size: 16 },
  "WjhOoy": { Icon: SecurityAlertFillIcon, size: 24 },
  "QyvFl9": { Icon: SecurityAlertFillIcon, size: 32 },
  "hLUDah": { Icon: SecurityAlertOutlineIcon, size: 24 },
  "UncL1M": { Icon: SecurityAlertOutlineIcon, size: 32 },
  "w0TdNz": { Icon: SecurityCheckFillIcon, size: 16 },
  "DibART": { Icon: SecurityCheckFillIcon, size: 24 },
  "lmnYxm": { Icon: SecurityCheckFillIcon, size: 32 },
  "H6mcN9": { Icon: SecurityCheckOutlineIcon, size: 24 },
  "Racp5N": { Icon: SecurityCheckOutlineIcon, size: 32 },
  "jOhJP9": { Icon: SecurityLockFillIcon, size: 16 },
  "bKWmbU": { Icon: SecurityLockFillIcon, size: 24 },
  "PFbzdL": { Icon: SecurityLockFillIcon, size: 32 },
  "2QZJ1D": { Icon: SecurityLockOutlineIcon, size: 24 },
  "TCNJKb": { Icon: SecurityLockOutlineIcon, size: 32 },
  "1yLk9x": { Icon: SelfEmployedIcon, size: 24 },
  "6t5OaM": { Icon: SendIcon, size: 16 },
  "v5VzJM": { Icon: SendIcon, size: 24 },
  "DII5RI": { Icon: SendArrowIcon, size: 16 },
  "GLXxj0": { Icon: SendArrowIcon, size: 24 },
  "CzvG52": { Icon: SensitiveHiddenIcon, size: 16 },
  "8XY5dW": { Icon: SensitiveHiddenIcon, size: 24 },
  "ImnSYa": { Icon: SensitiveVisibleIcon, size: 16 },
  "byOo1O": { Icon: SensitiveVisibleIcon, size: 24 },
  "K5VLfs": { Icon: SettingsIcon, size: 24 },
  "SGLp01": { Icon: ShareIcon, size: 16 },
  "WK4dHG": { Icon: ShareIcon, size: 24 },
  "on6UuU": { Icon: ShareAndroidIcon, size: 24 },
  "GDjQp4": { Icon: ShopInStoreIcon, size: 24 },
  "cAHbWH": { Icon: ShoppingBagIcon, size: 24 },
  "cNY4os": { Icon: ShoppingCartIcon, size: 24 },
  "f05sKf": { Icon: SkippedIcon, size: 16 },
  "91IvX2": { Icon: SkippedIcon, size: 24 },
  "2GDcAR": { Icon: SkippedIcon, size: 32 },
  "FNnFcC": { Icon: StarCircledIcon, size: 24 },
  "A2Iayc": { Icon: StickersIcon, size: 16 },
  "OlVQrG": { Icon: StickersIcon, size: 24 },
  "SqQCP9": { Icon: StickersIcon, size: 32 },
  "uLext7": { Icon: StopIcon, size: 16 },
  "jqTCLe": { Icon: StopIcon, size: 24 },
  "5Cmg27": { Icon: StudentIcon, size: 24 },
  "3E2uEv": { Icon: SubtleExpandIcon, size: 16 },
  "3AvhmC": { Icon: SubtleMoreIcon, size: 16 },
  "Hwv9dE": { Icon: SubtlePushIcon, size: 16 },
  "UoEioz": { Icon: SubtractIcon, size: 16 },
  "lGc5l5": { Icon: SubtractIcon, size: 24 },
  "C8vWOt": { Icon: SubtractIcon, size: 32 },
  "rKdGnG": { Icon: SubtractFillIcon, size: 16 },
  "b1cyvE": { Icon: SubtractFillIcon, size: 24 },
  "mXXDZB": { Icon: SubtractFillIcon, size: 32 },
  "76t1aJ": { Icon: SubtractOutlineIcon, size: 16 },
  "MUqIe8": { Icon: SubtractOutlineIcon, size: 24 },
  "t3OkJD": { Icon: SupportFillIcon, size: 16 },
  "qJwvkC": { Icon: SupportFillIcon, size: 24 },
  "XdpN2B": { Icon: SupportFillIcon, size: 32 },
  "dr5bht": { Icon: SwapCurrencyIcon, size: 16 },
  "GXhVdK": { Icon: SwapCurrencyIcon, size: 24 },
  "QJnuK9": { Icon: SwapCurrencyIcon, size: 32 },
  "OcuDAi": { Icon: SwitcherIcon, size: 16 },
  "g1bp90": { Icon: TapToPayIcon, size: 24 },
  "ZdV3lW": { Icon: TapToPayIcon, size: 32 },
  "NFXavb": { Icon: TaxesIcon, size: 16 },
  "b9UR6C": { Icon: TaxesIcon, size: 24 },
  "aBrkvr": { Icon: TaxesIcon, size: 32 },
  "zj6z29": { Icon: TeachingExpenseIcon, size: 24 },
  "P3Fs7g": { Icon: TextIcon, size: 16 },
  "DLkilj": { Icon: TextIcon, size: 24 },
  "zm9cCA": { Icon: TextIcon, size: 32 },
  "triX7D": { Icon: ThemesIcon, size: 24 },
  "wnaSfx": { Icon: ThumbsDownIcon, size: 16 },
  "5rj873": { Icon: ThumbsUpIcon, size: 16 },
  "iCxNT5": { Icon: TickerDownIcon, size: 16 },
  "XHgV42": { Icon: TickerDownIcon, size: 24 },
  "Ul4yxW": { Icon: TickerUpIcon, size: 16 },
  "YN7NX1": { Icon: TickerUpIcon, size: 24 },
  "mi6Uah": { Icon: TimeIcon, size: 16 },
  "35X0rU": { Icon: TimeIcon, size: 24 },
  "phZiLT": { Icon: TimeIcon, size: 32 },
  "ECSBnx": { Icon: TimeFillIcon, size: 16 },
  "mAZJ2O": { Icon: TimeFillIcon, size: 24 },
  "5eGm9a": { Icon: TimeFillIcon, size: 32 },
  "dAUnMV": { Icon: TimeHourglassIcon, size: 16 },
  "FVF5Xh": { Icon: TimeHourglassIcon, size: 24 },
  "oFuRtZ": { Icon: TimeHourglassIcon, size: 32 },
  "ygxg3c": { Icon: TimeInfiniteIcon, size: 16 },
  "Mm7naz": { Icon: TimeInfiniteIcon, size: 24 },
  "cpk4Lq": { Icon: TimeInfiniteIcon, size: 32 },
  "EhlAhL": { Icon: TimeProgressStartIcon, size: 16 },
  "QpwE77": { Icon: TimeProgressStartIcon, size: 24 },
  "ZfQglU": { Icon: TimeStopwatchIcon, size: 16 },
  "StkLXb": { Icon: TimeStopwatchIcon, size: 24 },
  "3Bmw1r": { Icon: TimeStopwatchIcon, size: 32 },
  "R0hRNb": { Icon: TrafficIcon, size: 24 },
  "2My33y": { Icon: TransferP2PIcon, size: 16 },
  "KfLRUr": { Icon: TransferP2PIcon, size: 24 },
  "g6aEov": { Icon: TransferP2PIcon, size: 32 },
  "ycVbga": { Icon: TransferWireIcon, size: 16 },
  "TJHM73": { Icon: TransferWireIcon, size: 24 },
  "358oXO": { Icon: TransferWireIcon, size: 32 },
  "XMUC7o": { Icon: UndoIcon, size: 24 },
  "XHT4oT": { Icon: UndoIcon, size: 32 },
  "4i7yY1": { Icon: UndoIcon, size: 16 },
  "pkQd7c": { Icon: UptrendIcon, size: 16 },
  "eLICIs": { Icon: VigationChatHistoryIcon, size: 24 },
  "5dkChU": { Icon: VigationCopyIcon, size: 24 },
  "gXonmd": { Icon: VigationLocalIcon, size: 24 },
  "d9g2L6": { Icon: VigationMenuAfterpayIcon, size: 24 },
  "ILYipj": { Icon: VigationMoneybotIcon, size: 24 },
  "Y4Gitg": { Icon: VigationMoneybotAltIcon, size: 24 },
  "9WQ03z": { Icon: VigationNewChatIcon, size: 24 },
  "rKJmrL": { Icon: WalletIcon, size: 16 },
  "VbipnJ": { Icon: WalletIcon, size: 24 },
  "KIdkA5": { Icon: WalletIcon, size: 32 },
  "VT2abM": { Icon: WalletFillIcon, size: 16 },
  "pyApXH": { Icon: WalletFillIcon, size: 24 },
  "apfnkh": { Icon: WalletFillIcon, size: 32 },
  "noiFym": { Icon: ZeroIcon, size: 16 },
  "RaZTsC": { Icon: ZeroIcon, size: 24 }
};
